import _ from 'lodash'

import { activity as atThePlaceActivity } from './AtThePlace/config'
import { activity as fileActivity } from './File/config'
import { activity as iframeActivity } from './Iframe/config'
import { LevelPlayIntro } from './Intro'
import { activity as jigsawActivity } from './Jigsaw/config'
import { activity as memoryActivity } from './Memory/config'
import { activity as mosaicActivity } from './Mosaic/config'
import { activity as questionActivity } from './Question/config'
import { activity as slideActivity } from './Slide/config'
import { activity as sortedActivity } from './Sorted/config'
import { activity as storiesActivity } from './Stories/config'
import { activity as thisOrThatActivity } from './ThisOrThat/config'
import { LevelPlayVideo } from './Video'
import { activity as wordHuntActivity } from './WordHunt/config'

/**
 * Catálogo único de tipos de desafio, servido a jornada e quiz.
 *
 * **`initial` não está aqui.** Ele é a tela de abertura do recurso — mostra
 * nome, recompensas, condição de bloqueio e botão de reset — e portanto precisa
 * do registro de domínio (`level`, `quiz`, `config`). Não satisfaz o contrato de
 * kind, que proíbe acessar contexto de domínio. Cada domínio injeta o seu via
 * `buildConfigs`.
 */

export const KINDS = {
  INITIAL: 'initial',

  INTRO: 'intro',
  VIDEO: 'video',
  SLIDE: 'slide',
  IFRAME: 'iframe',
  FILE: 'file',

  QUESTION: 'question',
  STORIES: 'stories',

  MEMORY: 'memory',
  WORD_HUNT: 'word_hunt',
  SORTED: 'sorted',
  JIGSAW: 'jigsaw',
  MOSAIC: 'mosaic',
  THIS_OR_THAT: 'this_or_that',
  // `AT_THE_Place` ate aqui — erro de digitacao vindo do commit inicial, nos
  // dois dominios. O valor sempre esteve certo, entao o filtro em runtime
  // funcionava; quem quebrava era `KINDS.AT_THE_PLACE`, que devolvia undefined.
  AT_THE_PLACE: 'at_the_place',

  // Aliases que só o backend do quiz emite. O catálogo é **superset**: adotar
  // apenas os slugs da jornada faria `getConfigByKind` devolver `undefined`
  // para toda pergunta de quiz com estes `kind`, e o step não montaria.
  MULTIPLE_CHOICE_QUESTION: 'multiple_choice_question',
  TEXT_QUESTION: 'text_question'
}

/** Kinds que não dependem de domínio — o catálogo compartilhado de fato. */
export const sharedConfigs = [
  {
    SLUG: KINDS.INTRO,
    Component: LevelPlayIntro
  },
  {
    SLUG: KINDS.VIDEO,
    Component: LevelPlayVideo
  },
  fileActivity,
  memoryActivity,
  questionActivity,
  { ...questionActivity, SLUG: KINDS.MULTIPLE_CHOICE_QUESTION },
  { ...questionActivity, SLUG: KINDS.TEXT_QUESTION },
  slideActivity,
  wordHuntActivity,
  sortedActivity,
  jigsawActivity,
  iframeActivity,
  mosaicActivity,
  storiesActivity,
  thisOrThatActivity,
  atThePlaceActivity
]

/**
 * Compõe o catálogo do domínio: a tela `initial` dele mais o catálogo
 * compartilhado.
 */
/**
 * Kinds sem contagem de tempo — conteúdo estático ou com controle de tempo
 * próprio (vídeo). Fonte única: consumido pelos dois domínios via o `config.js`
 * de cada um, em vez de duplicar o literal em cada `HeartsAndCountdown`.
 */
export const NO_TIME_KINDS = [
  KINDS.SLIDE,
  KINDS.STORIES,
  KINDS.IFRAME,
  KINDS.VIDEO,
  KINDS.FILE
]

export const buildConfigs = (domainConfigs = []) => [
  ...domainConfigs,
  ...sharedConfigs
]

export const buildGetConfigByKind = configs => kind =>
  _.find(configs, { SLUG: kind })
